import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { errorMsg } from '../../../../../../../Apis/functions';
import { permissionObj } from '../../../../../../../Helpers/permission';
import {
    GetAllDeductionPolicies,
} from '../../../../../../../reduxToolkit/DeductionPolicy/DeductionPolicyApi';
import {DeleteItemsApi} from "../../../../../../../reduxToolkit/Commons/CommonsApi";
import {TABLES} from "../../../../../../../Apis/Tables";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTitle: Full Stack Developer
 */

/**
 * Logic hook for the deduction policy management view.
 * @param {Function} registerAction - Registers the create action for the parent tab toolbar.
 * @param {string} subView - Current sub-view identifier.
 * @returns {Object} State and handlers for the deduction policy section.
 */
const DeductionPolicyApp = ({ registerAction, subView }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const DEV = useSelector((s) => s?.CommonsSlice?.development);
    const { permission } = useSelector((s) => s.authenticatioauthennSlice);

    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const canCreate = DEV || permission?.includes(permissionObj?.WEB_PAYROLL_DEDUCTION_POLICY_CREATE);
    const canUpdate = DEV || permission?.includes(permissionObj?.WEB_PAYROLL_DEDUCTION_POLICY_UPDATE);
    const canDelete = DEV || permission?.includes(permissionObj?.WEB_PAYROLL_DEDUCTION_POLICY_DELETE);

    const handleCreate = () => setShowCreateModal(true);

    useEffect(() => {
        registerAction(subView, { handleCreate });
        getData();
    }, []);

    /**
     * Fetches all deduction policies from the server.
     */
    const getData = () => {
        dispatch(GetAllDeductionPolicies()).then(({ payload: { data: { data, success, code } } }) => {
            if (success) setItems(data ?? []);
            else errorMsg(code);
        });
    };

    /**
     * Opens the update modal for the selected policy.
     * @param {Object} row - Policy to edit.
     */
    const handleOpenUpdate = (row) => {
        setSelectedItem(row);
        setShowUpdateModal(true);
    };

    /**
     * Opens the delete confirmation modal for the selected policy.
     * @param {Object} row - Policy to delete.
     */
    const handleOpenDelete = (row) => {
        setSelectedItem(row);
        setShowDeleteModal(true);
    };

    /**
     * Deletes the currently selected deduction policy.
     */
    const handleSubmitDelete = () => {
        dispatch(DeleteItemsApi({ tableName: TABLES.PAYROLL_DEDUCTION_POLICY, body:[selectedItem.id] }))
            .then(({ payload: { data: { success, code } } }) => {
            if (success) {
                setShowDeleteModal(false);
                setSelectedItem(null);
                getData();
            } else errorMsg(code);
        });
    };

    return {
        t,
        canCreate,
        canUpdate,
        canDelete,
        items,
        getData,
        selectedItem,
        setSelectedItem,
        showCreateModal,
        setShowCreateModal,
        showUpdateModal,
        setShowUpdateModal,
        showDeleteModal,
        setShowDeleteModal,
        handleCreate,
        handleOpenUpdate,
        handleOpenDelete,
        handleSubmitDelete,
    };
};

export default DeductionPolicyApp;
